import { Flip, toast, ToastOptions } from "react-toastify";

const props: ToastOptions = {
  position: "bottom-right",
  autoClose: 1250,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  transition: Flip,
};

export const showError = (message: string) => {
  toast.error(message, props);
};

export const showWarning = (message: string) => {
  toast.warning(message, props);
};

export const showSuccess = (message: string) => {
  toast.success(message, props);
};

export const showGenericSuccess = () => {
  showSuccess("Valmis!");
};

export const showGenericError = () => {
  showError("Toiminto epäonnistui!");
};
